import { Col, Container, Row, Button } from "design-react-kit";
import Breadcrumbs from "../../components/Breadcrumbs";
import React, { useState } from "react";
import Section from "../../components/Section";
import SectionTitle from "../../components/SectionTitle";
import Input from "../../components/inputs/Input";

const FeedbackPage = (props) => {
  const [form, setForm] = useState({
    pagineSegnalate: "",
    pagineNonConformi: "",
    strumenti: "",
    nome: "",
    cf: "",
    email: "",
  });

  const handleChange = (field) => (e) => {
    const value = e?.target?.value ?? e;
    setForm((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleSubmit = () => {
    console.log(form);
  };

  const handleReset = () => {
    setForm({
      pagineSegnalate: "",
      pagineNonConformi: "",
      strumenti: "",
      nome: "",
      cf: "",
      email: "",
    });
  };

  return (
    <>
      <Breadcrumbs
        {...props}
        items={[
          { to: "/", label: "website.navbar.home" },
          { to: "/feedback", label: "Meccanismo Feedback" },
        ]}
      />

      <Section className="pt-0">
        <Container>
          <Row tag="div" className="mt-3 mb-3">
            <Col xs="12">
              <div className="section-title-container">
                <h3>Meccanismo di Feedback</h3>
              </div>
            </Col>
          </Row>
        </Container>

        <Container>
          <Row>
            <Col lg={10} md={12}>
              <p>
                {" "}
                Si indica di seguito l'indirizzo e-mail cui inoltrare
                segnalazioni relative ad eventuali difetti , in termini di
                conformità ai principi generali per l'accessibilità previsti
                dall'art. 3-bis della Legge n. 4/2004 e s.m.i. e alle
                prescrizioni delle Linee guida sull'accessibilità degli
                strumenti informatici" del 26/11/2019 emanate da AGID. <br /> Al
                medesimo indirizzo e-mail possono essere indirizzati eventuali
                suggerimenti atti a migliorare l'accessibilità delle
                pagine.{" "}
              </p>
              <p>
                {" "}
                <strong>
                  Indirizzo e-mail a cui inviare la segnalazione
                </strong>{" "}
                :&nbsp;{" "}
                <a href="mailto:direzione.informatica@regione.campania.it">
                  {" "}
                  direzione.informatica@regione.campania.it{" "}
                </a>{" "}
              </p>{" "}
              <p>
                {" "}
                Le risposte alle segnalazione sono gestite nel termine di 30
                giorni che forniranno tempi e modi per la risoluzione della
                richiesta a seconda della complessità della problematica
                individuata.{" "}
              </p>{" "}
              <p>
                {" "}
                Il link di accesso al Meccanismo di feedback, con la relativa
                descrizione di utilizzo, è disponibile anche all'interno della
                Dichiarazione di accessibilità.{" "}
              </p>{" "}
              <p>
                {" "}
                L'utente può ricorrere altresì al Difensore Civico per il
                Digitale tramite l'apposito riferimento presente sul modello di
                dichiarazione di accessibilità qualora, entro trenta giorni
                dalla notifica o dalla richiesta di informazioni, il soggetto
                erogatore non risponda o fornisca una risposta
                insoddisfacente.{" "}
              </p>
            </Col>
          </Row>
          <Row className="justify-content-md-center mt-5">
            <Col lg={8} md={12}>
              <h3 className="mb-4">Dati del richiedente</h3>
              <Row>
                <Col md={6}>
                  <Input
                    label="Nome e cognome*"
                    type="text"
                    value={form.nome}
                    onChange={handleChange("nome")}
                  />
                </Col>

                <Col md={6}>
                  <Input
                    label="Codice fiscale*"
                    type="text"
                    value={form.cf}
                    onChange={handleChange("cf")}
                  />
                </Col>
              </Row>

              <Input
                label="Indirizzo email o PEC*"
                type="email"
                value={form.email}
                onChange={handleChange("email")}
              />

              <h3 className="mt-5 mb-3">Oggetto della richiesta di feedback</h3>

              <p>
                <strong>Oggetto della segnalazione:</strong> Sito web
              </p>
              <p>
                <strong>URL del servizio digitale:</strong>{" "}
                https://amministrazionetrasparente.regione.campania.it/
              </p>

              <h3 className="mt-5 mb-4">Descrizione della richiesta</h3>

              <Input
                label="Pagine web/sezioni del sito web segnalate*"
                className="label-position"
                type="textarea"
                value={form.pagineSegnalate}
                onChange={handleChange("pagineSegnalate")}
              />

              <Input
                label="Pagine web/sezioni del sito web non conformi*"
                type="textarea"
                className="label-position"
                value={form.pagineNonConformi}
                onChange={handleChange("pagineNonConformi")}
              />

              <Input
                label="Strumenti in dotazione*"
                className="label-position"
                type="textarea"
                value={form.strumenti}
                onChange={handleChange("strumenti")}
              />
              <div
                style={{ columnGap: "16px", justifyContent: "flex-end" }}
                className="d-flex mt-5"
              >
                <Button color="danger" outline onClick={handleReset}>
                  Pulisci i campi
                </Button>

                <Button color="primary" onClick={handleSubmit}>
                  Invia
                </Button>
              </div>
            </Col>
          </Row>
        </Container>
      </Section>
    </>
  );
};

export default FeedbackPage;
